/* import __COLOCATED_TEMPLATE__ from './choose-dac.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import Constants from '../../utils/constants';

export default class ChooseDacModal extends Component {
  get modalType() {
    return Constants.MODAL_TYPES.CHOOSE_DAC.value;
  }

  get dac() {
    const dacFound = this.args.model && this.args.model.signalChainHandler && this.args.model.signalChainHandler.dac;
    if (!dacFound) return null;

    return this.args.model.signalChainHandler.dac;
  }

  get gridData() {
    if (!(this.dac && this.dac.gridData && this.dac.gridData.data && this.dac.gridData.view)) {
      return { data: null, view: null };
    }

    return this.dac.gridData;
  }

  @action setSelectedItem(selectedItem) {
    if (selectedItem) {
      this.dac.selected = selectedItem;
    }
  }

  @action handleDacSelection() {
    this.args.model.markAsNotReady();
    this.args.model.handleDacChange(this.dac);
    if (this.args.updateAppData) this.args.updateAppData();
    this.args.model.markAsReady();
  }
}
